const names = ['badger', 'chipmunk', 'horse', 'squirrel', 'orangatang', 'beaver', 'giraffe', 'zebra', 'chimpanzee', 'ox', 'monkey', 'panda', 'tiger', 'gorilla']
const random_rgba = () => {
    var o = Math.round, r = Math.random, s = 255;
    return 'rgba(' + o(r()*s) + ',' + o(r()*s) + ',' + o(r()*s) + ',' + r().toFixed(1) + ')';
}

export default function (leader) {

    this.displayName = leader && leader.displayName || `Anonymous ${names[Math.floor(Math.random() * names.length)]}`;
    this.bounty_points = leader && leader.bounty_points || 0;
    this.color = leader && leader.color || random_rgba();
    this.bets_won = leader && leader.bets_won || 0;

}


// WEBPACK FOOTER //
// ./src/schemas/leader.js